import React, { useState, useEffect } from 'react';
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL } from "assets/constants/Constants";
import { EDIT_ICON, TRASH_ICON, CALENDER_ICON } from "assets/constants/Icons";
import Spinner from 'components/Spinner';
import ShowToast from 'components/ShowToast';
import { hasPermission } from 'components/Permission';
import { getBusinessVerticalList, createBusinessVertical, updateBusinessVertical, deleteBusinessVertical,createHistoryList } from "lib/axiosUtils";
import { LOG_TEXT, MODULE_NAMES } from 'assets/constants/Constants';
import { Divider } from '@mui/material';
import { BusinessIcon} from 'assets/constants/Icons';
import moment from 'moment';

const BusinessVerticalPage = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [name, setName] = useState("");
    const [nameId, setNameId] = useState(null);
    const [buttonText, setButtonText] = useState("Add BV");
    const [bvList, setBvList] = useState([]);
    const [error, setError] = useState({});

    useEffect(() => {
        fetchBVList();
    }, []);

    const fetchBVList = async () => {
        setIsLoading(true);
        const response = await getBusinessVerticalList({}, {});
        setBvList(response.data.result || []);
        setIsLoading(false);
    };

    const nameChange = (event) => {
        setName(event.target.value);
    };

    const isFormValid = () => {
        let isValid = true;
        let errorData = {};
        if (name.trim() === "") {
            isValid = false;
            errorData.name = "Please add BV name";
        }
        setError(errorData);
        return isValid;
    };

    const isSuccess = (response) => {
        return response && (
            response.status === 200 ||
            response.statusCode === 200 ||
            response.status === 201 ||
            response.statusCode === 201 ||
            response.status === 204 ||
            response.statusCode === 204
        );
    };

    const addNameHandler = async () => {
        if (isFormValid()) {
            setIsLoading(true);
            const requestData = { name };
            let response = null;
            let auditresponse=null;
            let userData = JSON.parse(localStorage.getItem('userData'));
            let userID = userData._id;
            let logText = LOG_TEXT.BV_ADDED;
            let moduleName = MODULE_NAMES.BUSINESS_VERTICAL;
            
            if (nameId === null) {
                response = await createBusinessVertical({}, requestData);
            } else {
                response = await updateBusinessVertical({}, requestData, nameId);
            }

            if (isSuccess(response)) {
                await fetchBVList();
                const tempId = nameId;
                setName("");
                setNameId(null);
                setButtonText("Add BV");
                setIsLoading(false);
                if (tempId === null) {
                    const bvData = response.data.result;
                    const auditData = {
                        logText,
                        userID,
                        moduleName,
                        doc_id: bvData._id
                    };
                    auditresponse = await createHistoryList({}, auditData);
                    ShowToast('BV created successfully', TYPE_SUCCESS, INTERVAL, props, "");
                } else {
                    ShowToast('BV updated successfully', TYPE_SUCCESS, INTERVAL, props, "");
                }
            } else {
                setIsLoading(false);
                ShowToast('Operation failed', TYPE_FAIL, INTERVAL, props, "");
            }
        }
    };

    const handleEdit = (item) => {
        setNameId(item._id);
        setName(item.name);
        setButtonText("Update BV");
    };

    const handleDelete = async (item) => {
        if (window.confirm("Are you sure you want to delete this BV?")) {
            setIsLoading(true);
            const response = await deleteBusinessVertical({}, {}, item._id);
            if (isSuccess(response)) {
                await fetchBVList();
                setName("");
                setNameId(null);
                setButtonText("Add BV");
                setIsLoading(false);
                ShowToast('BV deleted successfully', TYPE_SUCCESS, INTERVAL, props, "");
            } else {
                setIsLoading(false);
                ShowToast('Something went wrong. Please try again.', TYPE_FAIL, INTERVAL, props, "");
            }
        }
    };

    return (
        <div className="main-content">
            <div className="pagetitle row" style={{ color: 'black', paddingTop: 15, marginTop: "-25px" }}>
                <div className="col-md-10 sm_device">
                    <BusinessIcon aria-hidden="true" />
                    <span style={{ marginLeft: '7px' }}>Business Vertical</span>
                </div>
                <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}>
                    <i className={`${CALENDER_ICON}`}></i> {moment().format('DD MMM YYYY')}
                </div>
            </div>
            <Divider sx={{ mb: 2, mt:2 }} />
            <div className="back">
                <ul className="breadcrumb1">
                    <li>Business Vertical</li>
                </ul>
            </div>
            <div className="role-wrapper">
                <div className="input-div">
                    <div>
                        <input
                            className="form-control brand-font placeholderColor add-role-input"
                            style={{ padding: "2rem", fontSize: "1.3rem" }}
                            value={name}
                            onChange={nameChange}
                            placeholder="Enter Business Vertical name"
                        />
                        <div className="text-danger error-msg">
                            {error.name}
                        </div>
                    </div>
                    <div>&nbsp;</div>
                    {
                        hasPermission('business_vertical', 'create') && (
                            <button className="brand-button ml-5 role-button" onClick={addNameHandler}>
                                {buttonText}
                            </button>
                        )
                    }
                </div>

                {isLoading ? (
                    <Spinner />
                ) : (
                    <div className="mt-5 mb-5 border user-table-div">
                        {bvList.length > 0 ? (
                            <table className="table list-table role-table">
                                <thead>
                                    <tr>
                                        <th className="pl1">Business Vertical</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="role-list-table">
                                    {bvList.map((item) => (
                                        <tr key={item._id}>
                                            <td className="role-td pl1">{item.name}</td>
                                            <td className="action-td center">
                                                <div className="action-div">
                                                    {
                                                        hasPermission('business_vertical', 'update') && (
                                                            <span onClick={() => handleEdit(item)}>
                                                                <i className={EDIT_ICON} title="Edit BV"></i>
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        hasPermission('business_vertical', 'delete') && (

                                                        <span onClick={() => handleDelete(item)}>
                                                            <i className={TRASH_ICON} title="Delete BV"></i>
                                                        </span>
                                                        )
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="text-center pt-2">
                                <label>No Business Verticals found!</label>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BusinessVerticalPage;
